import { API_URL } from '../../environment';
import { forCalendarRange } from '../../actions/misc';
import { ducksActionCreator } from '../ducksHelpers';

export const blockedSlotsSettings = {
  stateName: 'blockedSlots',
  dataType: 'array',
  actions: {
    fetch: 'ducks/schedule/FETCH_BLOCKED_SLOTS',
  },
};

// Action Creators
// With a counsellorId (admin schedule) requests go through the admin API;
// otherwise the practitioner lists their own blocked slots.
export function fetchBlockedSlots(
  start,
  end,
  callback = () => {},
  errorCallback = () => {},
  counsellorId = null,
) {
  const range = `start=${encodeURIComponent(
    start.toISOString(),
  )}&end=${encodeURIComponent(end.toISOString())}`;
  const url = counsellorId
    ? `${API_URL}/admin/blocked_slots?counsellor=${counsellorId}&${range}`
    : `${API_URL}/practice/blocked_slots?${range}`;

  return forCalendarRange(
    start,
    end,
    ducksActionCreator(
      blockedSlotsSettings.actions.fetch,
      'get',
      url,
      {},
      true,
      callback,
      errorCallback,
    ),
  );
}
